var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.172,
    height: 13.922,
    viewBox: "0 0 15.172 13.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1439",
    "data-name": "Group 1439",
    transform: "translate(0 0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M30.045,172.8H24.436a1.887,1.887,0,0,1-1.967-1.958q0-1.205,0-2.41a.634.634,0,1,1,1.262,0q0,1.185,0,2.37a.656.656,0,0,0,.733.731H35.642a.654.654,0,0,0,.734-.729c0-.81,0-1.619,0-2.429a.63.63,0,0,1,1.23-.2.778.778,0,0,1,.031.232c0,.836,0,1.672,0,2.508a1.882,1.882,0,0,1-1.886,1.88q-2.854.006-5.708,0Z",
    transform: "translate(-22.468 -158.884)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M97.709,9.418V.68c0-.451.31-.76.665-.667A.643.643,0,0,1,98.8.688V9.422c.062-.053.105-.088.146-.126l1.7-1.578a.5.5,0,0,1,.8.079.7.7,0,0,1-.116.907q-1.34,1.249-2.683,2.492a.5.5,0,0,1-.784,0q-1.311-1.211-2.618-2.429a.7.7,0,0,1-.109-.894.494.494,0,0,1,.785-.1c.548.5,1.091,1.009,1.637,1.513.042.039.087.074.155.131Z",
    transform: "translate(-90.701 -0.005)",
    fill: "#434343"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.fce1923131ba99b193e83c2fa6320119.svg";
export { ForwardRef as ReactComponent };